import { gsap } from "gsap";
import DrawSVGPlugin from '../../plugins/gsap/DrawSVGPlugin';
import PageCreatorStackHorizontalScroll from "./PageCreatorStackHorizontalScroll";
import BackgroundSwitcher from "../animation/BackgroundSwitcher";

gsap.registerPlugin(DrawSVGPlugin);
class PageCreatorStack {
    constructor() {
        this.heroEl = document.querySelector('.hero-creator-stack');
        if(this.heroEl) {
            this.initHero();
        }

        this.initHorizontalScroll();

        this.initBackgroundAnimation();
    }

    initHero() {
        this.heroAppear = document.querySelectorAll('[data-hero-appear], [data-hero-appear-text] > *');
        gsap.set(this.heroAppear, {autoAlpha: 0, y: "+=30"});
        gsap.set(".hero-creator-stack .container", {autoAlpha: 1});
        const tagNew = document.querySelector('.hero-creator-stack .clf-underline');

        this.heroTimeline = gsap.timeline();
        this.heroTimeline
            .to(this.heroAppear, {autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.1, ease: "power2.out"}, 0.5);

        if(tagNew) {
            this.heroTimeline.add(() => {
                tagNew.classList.add('clf-underline-draw');
            }, .6)
        }

        const titleHandwritingEl = document.querySelectorAll('.handwriting-stroke-animation');
        if(titleHandwritingEl.length) {
            const speed = 0.2;
            gsap.set(titleHandwritingEl, {drawSVG: '0%'}); //Set the initial state of the path
            const animate = (index) => {
                if (index >= titleHandwritingEl.length) return;
                gsap.to(titleHandwritingEl[index], {
                    drawSVG: true, duration: speed, ease: 'none',
                    onStart: () => {
                        setTimeout(() => {
                            animate(index + 1);
                        }, 100);
                    }
                }); //Animate path
            };
            setTimeout(() => {
                animate(0);
            }, 1600);
        }
    }

    initHorizontalScroll() {
        const horizontalSliderEl = document.querySelector('.creator-stack-horizontal-slider');
        if(horizontalSliderEl){
            new PageCreatorStackHorizontalScroll(horizontalSliderEl);
        }
    }

    initBackgroundAnimation() {
        const backgroundSwitcherEl = document.querySelector('[data-background-switcher]');
        if(backgroundSwitcherEl) {
            new BackgroundSwitcher(backgroundSwitcherEl);
        }
    }
}

export default PageCreatorStack;
